import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useContext, useCallback } from 'react';
import { FormChangeSource } from './constants.js';
import FormContext$1 from './FormContext.js';

/**
 * A hook to get or set a single field value
 * @param {string} field The name of the field
 * @returns {[]} An array in the format: [value, setValue]
 * @returns {*} `value` The current field value
 * @returns {function} `setValue` A function to update the field value, can be passed the new field value or a function which receives the old value and returns the new value. Can also be passed an optional second parameter for change metadata to propagate to the form
 */

var useFormField = function useFormField(field) {
  var context = useContext(FormContext$1);
  var currentValue = context.value[field];
  var setValue = useCallback(function (value, metadata) {
    context.onChange(field, typeof value === "function" ? undefined : value, function (state) {
      var hasOldValue = state && state.hasOwnProperty(field);
      var oldValue = hasOldValue ? state[field] : undefined;
      var newValue = typeof value === "function" ? value(oldValue) : value;

      if (hasOldValue && oldValue === newValue) {
        return state;
      }

      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, field, newValue));
    }, metadata !== null && metadata !== void 0 ? metadata : {
      source: FormChangeSource.Other
    });
  }, [context.onChange, field]);
  return [currentValue, setValue];
};

var useFormField$1 = useFormField;

export { useFormField$1 as default };
